import { Label, Text } from "@primer/react";
import { ComplianceStatus } from "../ComplianceStatus/ComplianceStatus.jsx";
import { worstComplianceStatus } from "../../domain/compliance.js";
import { effectiveValue, evaluatePolicy } from "../../domain/document.js";
import "./PolicyStatus.css";

export function PolicyStatus({ document, policy }) {
  if (policy.enabled === false) return <span className="policy-status"><Label variant="secondary">Disabled</Label></span>;
  const count = policy.scope.type === "specific"
    ? document.assets.filter((asset) => effectiveValue(document, asset.id, policy.scope.propertyId).id === policy.scope.valueId).length
    : document.assets.length;
  const results = evaluatePolicy(document, policy);
  return <span className="policy-status"><ComplianceStatus status={worstComplianceStatus(results)} /><Text className="policy-scope-count">· {count} {count === 1 ? "asset" : "assets"}</Text></span>;
}
